import i18next, { currentLang } from "./index";

const API = process.env.REACT_APP_BACKEND_URL;
const CACHE_KEY = `epl_i18n_ov_${currentLang}`;

const apply = (entries) => {
  if (entries && Object.keys(entries).length) {
    i18next.addResources(currentLang, "translation", entries);
  }
};

const readCache = () => {
  try {
    const raw = window.localStorage.getItem(CACHE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

const fetchFresh = async () => {
  const res = await fetch(`${API}/api/i18n/overrides/${currentLang}`);
  if (!res.ok) throw new Error(res.statusText);
  const data = await res.json();
  try {
    window.localStorage.setItem(CACHE_KEY, JSON.stringify(data.entries || {}));
  } catch {}
  return data.entries || {};
};

// Team edits from /admin/translations override the built-in locale files.
// Cached copy renders instantly; a fresh copy is fetched for the next load.
export const bootI18n = async () => {
  const cached = readCache();
  if (cached) {
    apply(cached);
    fetchFresh().catch(() => {});
    return;
  }
  const timeout = new Promise((r) => setTimeout(r, 1500));
  await Promise.race([fetchFresh().then(apply).catch(() => {}), timeout]);
};
